module.exports = __webpack_public_path__ + "img/zpchb.2c94793f.png";